import React from "react";
import PropTypes from "prop-types";
import { Box, Grid, Typography, Divider } from "@mui/material";
import SharedToolTip from "../../../shared/sharedToolTip/SharedToolTip";
import { formatPriceValue } from "../../../utils/FormatPrice";

const formatNetEquity = (value) =>
  value !== null &&
  value !== undefined &&
  value !== "" &&
  Number.isFinite(Number(value))
    ? formatPriceValue(Number(value))
    : "--";

const PriceList = ({ amounts, netEquity, t }) => {
  return (
    <Box>
      <Grid container spacing={2}>
        {amounts.map((item) => (
          <React.Fragment key={item.heading}>
            <Grid item xs={7}>
              <Typography variant="body1" sx={{ mr: 1 }} display="inline">
                {item.heading}
              </Typography>
              {item.tooltip && <SharedToolTip body={item.tooltip.body} />}
            </Grid>
            <Grid item xs={5}>
              <Typography variant="body1" align="right">
                {typeof item.amount === "number"
                  ? `$${item.amount.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`
                  : "--"}
              </Typography>
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
      <Divider color="black" sx={{ my: 2, borderBottomWidth: 2 }} />
      <Grid container data-testid="trade-in-net-equity">
        <Grid item xs={6}>
          <Typography variant="h6">{t("tradeIn.netEquity")}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="h6" align="right">
            {formatNetEquity(netEquity)}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

PriceList.propTypes = {
  amounts: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      amount: PropTypes.number,
      tooltip: PropTypes.shape({
        body: PropTypes.string,
      }),
    })
  ).isRequired,
  netEquity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  t: PropTypes.func,
};

PriceList.defaultProps = {
  netEquity: null,
  t: () => "",
};

export default PriceList;
